import { get, post, put, del } from '../../api-config';
import { gdpService, getLocale } from './_service';

// Device search & detail
export const postDevices = async (data: any) => await post(gdpService, '/devices/search', data, null);
export const postNewDevice = (data: any) => post(gdpService, `/devices`, data, null);
export const getDevice = (id: any) => get(gdpService, `/devices/${id}`, null, null);
export const getDevicesByHwSerialNo = (data: any) =>
  get(gdpService, `/devices/hwSerialNo/${data.deviceHwSerial}`, null, null);
export const getDeviceGeneral = (id: any) => get(gdpService, `/devices/${id}/general`, null, null);
export const getDeviceTelecareStatus = (id: any) => get(gdpService, `/devices/${id}/status`, null, null);
export const getDeviceTelecareStatusHistory = (id: any, params: any) =>
  get(gdpService, `/devices/${id}/status/historic`, null, params);
export const getDeviceStatusHistoryList = (id: any, params: any) =>
  get(gdpService, `/devices/${id}/status/history`, null, params);
export const getDeviceStatusHistoryDetail = (id: any, historicId: any) =>
  get(gdpService, `/devices/${id}/status/history/${historicId}`, null, null);
// Búsqueda con filtros (scope fijo al dispositivo / periférico).
export const searchDeviceEvents = (id: any, body: any) =>
  post(gdpService, `/devices/${id}/events/search`, body, null);
export const searchDevicePeripheralEvents = (id: any, body: any) =>
  post(gdpService, `/devices/peripheral/${id}/events/search`, body, null);
export const getDeviceRefreshStatus = (id: any) =>
  get(gdpService, `/devices/${id}/refreshStatus`, null, null);
export const getDeviceUpdateOs = (id: any) => get(gdpService, `/devices/${id}/update_os`, null, null);
export const getDeviceRequest = (id: any, params: any) =>
  get(gdpService, `/devices/${id}/command`, null, params);

export const getHistoricDeviceUsers = (data: any) =>
  get(gdpService, `/devices/${data.id}/users/historic`, null, { init: data.init, size: data.size });

// Remote support (AnyDesk hoy; agnóstico de proveedor)
export const putDeviceRemoteSupport = (id: any, data: any) =>
  put(gdpService, `/devices/${id}/remote-support`, data, null);

// Device notes
export const postDeviceNote = (data: any) =>
  post(gdpService, `/devices/${data.referenceId}/notes`, data, null);
export const getDeviceNotes = (data: any) =>
  get(gdpService, `/devices/${data.id}/notes`, null, { init: data.init, size: data.size });
export const deleteDeviceNotes = (data: any) =>
  del(gdpService, `/devices/${data.referenceId}/notes/${data.noteId}`);

// Device types
export const getDevicesTypes = () => get(gdpService, '/devices/types', null, null);
export const getDeviceTypeById = (id: any) => get(gdpService, `/devices/types/${id}`, null, null);
export const postNewDeviceType = (data: any) => post(gdpService, '/devices/types', data, null);
export const putDeviceType = (data: any) => put(gdpService, '/devices/types', data, null);

// Peripherals (device-related catalogs)
export const getPeripheralsTypes = () => get(gdpService, '/peripherals/types', null, { locale: getLocale() });
export const getPeripherals = () => get(gdpService, '/peripherals', null, null);
export const getPeripheralsMeasureTypes = () => get(gdpService, '/peripherals/measure/types', null, null);
// Config de procesado por modelo (wearable, retraso, descarte en carga). Solo SUPERADMIN.
export const getPeripheralProcessingConfigs = () => get(gdpService, '/peripherals/processing-config', null, null);
export const putPeripheralProcessingConfig = (data: any) =>
  put(gdpService, `/peripherals/${data.id}/processing-config`, data, null);
